import Joi from "joi";

export const OrgWeeklyOffSchema=Joi.object({
    repeat:Joi.string().required().messages({
        "any.required": "Repeat is required.",
        "string.empty": "Repeat is required.",
    }),
    // selectedDay:Joi.string().required().messages({
    //     "any.required": "Day is required.",
    //     "string.empty": "Day is required.",
    // }),
    // is_payable: Joi.boolean().required().messages({
    //     "any.required": "payable is required",
    //     "boolean.base": "payable is required"
    // })
    days: Joi.number().required().messages({
        "any.required": "Days is required.",
        "number.base": "Days must be a number."
    }),
})